import React, {component} from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';
import NavDropdown from 'react-bootstrap/NavDropdown';
import './navbar.scss';


class TopNavbar extends React.Component {
    constructor(props){
        super(props);
        this.state = {
          searchKey:"",
        }

       
      }

   
  render(){

    return (
      <div className="main">
          
          <Navbar expand="lg" className={["bg-body-tertiary","navbar-strip"].join(" ")} >
            <Container>

            <Navbar.Brand style={{cursor:"pointer"}} onClick={(e)=>{this.props.setval({currentPage:"frontpage"})}}>
                  <img src={"/assets/yt-magasin-logo2.jpeg"} className={"nav-logo"} />
                </Navbar.Brand>


                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                <NavDropdown title="Artwork" id="basic-nav-dropdown">
                    <NavDropdown.Item onClick={(e)=>{
                       const cat_sublist = this.props.productList["wallart"]
                       for (var j in cat_sublist){
                         cat_sublist[j]["parentCategory"] = "wallart"
                       }
                       if (this.props.currentPage==="gridviewpage"){
                         this.props.setval({filter:cat_sublist,bannerCat:"wallart"})
                       } else {
                         this.props.setval({filter:cat_sublist,currentPage:"gridviewpage",bannerCat:"wallart"})
                       }
                      }}>
                        All
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={(e)=>{
                      this.props.searchProduct(e,"education","wallart")
                      }}>
                        Education
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={(e)=>{
                    this.props.searchProduct(e,"manuscript","wallart")  
                    }}>Manuscript</NavDropdown.Item>
                    {/* <NavDropdown.Divider /> */}
                    {/* <NavDropdown.Item href="#action/3.4">
                        Separated link
                    </NavDropdown.Item> */}
                    <NavDropdown.Item onClick={(e)=>{
                    this.props.searchProduct(e,"salon","wallart")  
                    }}>Salon</NavDropdown.Item>
                    </NavDropdown>



                    <NavDropdown title="Books" id="basic-nav-dropdown">
                    <NavDropdown.Item onClick={(e)=>{
                       const cat_sublist = this.props.productList["book"]
                       for (var j in cat_sublist){
                         cat_sublist[j]["parentCategory"] = "book"
                       }
                       if (this.props.currentPage==="gridviewpage"){
                         this.props.setval({filter:cat_sublist,bannerCat:"book"})
                       } else {
                         this.props.setval({filter:cat_sublist,currentPage:"gridviewpage",bannerCat:"book"})
                       }
                      }}>
                        All
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={(e)=>{
                      this.props.searchProduct(e,"education","book")
                      }}>
                        Education
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={(e)=>{
                    this.props.searchProduct(e,"history","book")  
                    }}>History</NavDropdown.Item>
                    {/* <NavDropdown.Divider /> */}
                    {/* <NavDropdown.Item href="#action/3.4">
                        Separated link
                    </NavDropdown.Item> */}
                    <NavDropdown.Item onClick={(e)=>{
                    this.props.searchProduct(e,"kids","book")  
                    }}>for Kids</NavDropdown.Item>
                    </NavDropdown>


                    <NavDropdown title="Collectables" id="basic-nav-dropdown">
                    <NavDropdown.Item onClick={(e)=>{
                       const cat_sublist = this.props.productList["tableware"]
                       for (var j in cat_sublist){
                         cat_sublist[j]["parentCategory"] = "tableware"
                       }
                       if (this.props.currentPage==="gridviewpage"){
                         this.props.setval({filter:cat_sublist,bannerCat:"tableware"})
                       } else {
                         this.props.setval({filter:cat_sublist,currentPage:"gridviewpage",bannerCat:"tableware"})
                       }
                      }}>
                        All
                    </NavDropdown.Item>
                    {/* <NavDropdown.Item onClick={(e)=>{
                      this.props.searchProduct(e,"education","book")
                      }}>
                        Education
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={(e)=>{
                    this.props.searchProduct(e,"history","book")  
                    }}>History</NavDropdown.Item>
                    <NavDropdown.Item onClick={(e)=>{
                    this.props.searchProduct(e,"kids","book")  
                    }}>for Kids</NavDropdown.Item> */}
                    </NavDropdown>


                    <NavDropdown title="YTICF" id="basic-nav-dropdown">
                    <NavDropdown.Item onClick={(e)=>{
                       const cat_sublist = this.props.productList["yticf"]
                       for (var j in cat_sublist){
                         cat_sublist[j]["parentCategory"] = "yticf"
                       }
                       if (this.props.currentPage==="gridviewpage"){
                         this.props.setval({filter:cat_sublist,bannerCat:"yticf"})
                       } else {
                         this.props.setval({filter:cat_sublist,currentPage:"gridviewpage",bannerCat:"yticf"})
                       }
                      }}>
                        All
                    </NavDropdown.Item>
                    </NavDropdown>


                    <NavDropdown title="Tuxedos" id="basic-nav-dropdown">
                    <NavDropdown.Item onClick={(e)=>{
                       const cat_sublist = this.props.productList["suit"]
                       for (var j in cat_sublist){
                         cat_sublist[j]["parentCategory"] = "suit"
                       }
                       if (this.props.currentPage==="gridviewpage"){
                         this.props.setval({filter:cat_sublist,bannerCat:"general"})
                       } else {
                         this.props.setval({filter:cat_sublist,currentPage:"gridviewpage",bannerCat:"general"})
                       }
                      }}>
                        All
                    </NavDropdown.Item>
                    </NavDropdown>


                   
                    {/* <NavDropdown title="Products" id="basic-nav-dropdown">
                    
                    <NavDropdown.Item onClick={(e)=>{
                      const cat_sublist = this.props.productList["wallart"]
                      for (var j in cat_sublist){
                        cat_sublist[j]["parentCategory"] = "wallart"
                      }
                      if (this.props.currentPage==="gridviewpage"){
                        this.props.setval({filter:cat_sublist})
                      } else {
                        this.props.setval({filter:cat_sublist,currentPage:"gridviewpage"})
                      }
                      }}>
                        Musical Artwork
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={(e)=>{
                      const cat_sublist = this.props.productList["book"]
                      for (var j in cat_sublist){
                        cat_sublist[j]["parentCategory"] = "book"
                      }
                      this.props.setval({filter:cat_sublist,currentPage:"gridviewpage"})}}>Books</NavDropdown.Item>
                    {/* <NavDropdown.Divider /> */}
                    {/* <NavDropdown.Item href="#action/3.4">
                        Separated link
                    </NavDropdown.Item> 
                    <NavDropdown.Item onClick={(e)=>{
                      const cat_sublist = this.props.productList["tableware"]
                      for (var j in cat_sublist){
                        cat_sublist[j]["parentCategory"] = "tableware"
                      }
                      this.props.setval({filter:cat_sublist,currentPage:"gridviewpage"})}}>Collectables</NavDropdown.Item>
                    </NavDropdown> */}
                    
                    <Nav.Link id={"learnedness"} className={["search-container","thirty-vw","nav-link-a"].join(" ")} onClick={(e)=>{
                      window.open("http://youngartistcompetition.org/iyao/about");
                      }}><i><b>{"Education Partners"}</b></i></Nav.Link>


                    <div className={["search-container","twenty-vw"].join(" ")}>
                        {/* <input type="text" placeholder="Search Products" name="search" onChange={(e)=>{
                          const key = e.target.value.toLowerCase()
                          this.setState({searchKey:key})
                        }} 
                        onKeyDown={(e)=>{
                          if(e.key === "Enter"){
                            this.searchProduct(e)
                          }
                        }}
                        /> */}
                        <Button className={"find"} onClick={(e)=>{
                          this.props.setval({searchModal:true})
                        }}><i className="fa fa-search"></i></Button>
                    </div>

                    <div className={["cart-container"].join(" ")} onClick={(e)=>{
                      this.props.setval({currentPage:"shoppingcart"})
                    }}>
                      
                      <Button className="gray"><img src="/assets/shoppingcart.svg" width="30px" />{"  Cart"}</Button>
                      {
                        (Object.keys(this.props.shoppingCart).length>0)&&
                        <div className="navbar-popcircle">{Object.keys(this.props.shoppingCart).length}</div>
                      }
                      
                    </div>
                    


                   
                </Nav>
                </Navbar.Collapse>
            </Container>
            </Navbar>

      </div>
    );


  }
}

export default TopNavbar;
